import { type ReactNode } from "react";
import { Button } from "@cieda/djayma-ui";
import { Inbox } from "lucide-react";

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

export interface EmptyStateProps {
  readonly icon?: ReactNode;
  readonly title: string;
  readonly description?: string;
  readonly action?: {
    readonly label: string;
    readonly onClick: () => void;
  };
}

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

export function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center px-4 py-16 text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-stone-100 text-stone-400">
        {icon ?? <Inbox className="h-6 w-6" />}
      </div>

      <h3 className="mt-4 font-display text-lg font-semibold text-stone-900">
        {title}
      </h3>

      {description && (
        <p className="mt-1.5 max-w-sm text-sm text-stone-500">{description}</p>
      )}

      {action && (
        <Button className="mt-5" onClick={action.onClick}>
          {action.label}
        </Button>
      )}
    </div>
  );
}
